module.exports = __webpack_public_path__ + "img/logo_2@3x.b7900089.png";